import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const INTERACTION_STATUS_STYLES = {
    finished:              { bg: "green.100",  borderColor: "green.200",  color: "green.700" },
    inprogress:            { bg: "blue.100",   borderColor: "blue.200",   color: "blue.700" },
    holded:                { bg: "yellow.100", borderColor: "yellow.200", color: "yellow.700" },
    cancelled:             { bg: "red.100",    borderColor: "red.200",    color: "red.700" },
    qualifiedfornextstage: { bg: "purple.100", borderColor: "purple.200", color: "purple.700" },
    furtherselection:      { bg: "cyan.100",   borderColor: "cyan.200",   color: "cyan.700" },
    readytohire:           { bg: "teal.100",   borderColor: "teal.200",   color: "teal.700" },
    hired:                 { bg: "green.100",  borderColor: "green.200",  color: "green.700" },
    rejected:              { bg: "red.100",    borderColor: "red.200",    color: "red.700" },
    candidateresigned:     { bg: "gray.100",   borderColor: "gray.200",   color: "gray.700" },
};

const InteractionStatusBadge = ({ status }) => {
    const { t } = useTranslation("models");
    const key = status?.toLowerCase() ?? "inprogress";
    const style = INTERACTION_STATUS_STYLES[key] ?? INTERACTION_STATUS_STYLES.inprogress;
    return (
        <Badge
            bg={style.bg}
            borderColor={style.borderColor}
            borderWidth={1}
            variant="subtle"
            fontSize="xs"
            px={3}
            py={0.5}
            borderRadius={6}
            color={style.color}
        >
            {t(`conversationStatus.${key}`)}
        </Badge>
    );
};

export default InteractionStatusBadge;
